"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguage = void 0;
/* Locale is defined as <language>-<country>-<variant>.
 * For that reason, we can split by "-" and take the first value.
 *
 * Note:
 * Language will always exist.
 * e.g., "ca" (catalan)
 *
 * Country may be optional...
 * e.g., "ca-ES" (catalan, Spain)
 *
 * ...but is required if specifying variant.
 * e.g., "ca-ES-VALENCIA" (catalan, Spain, Valencia)
 */
var getLanguage = function (locale) { return locale.split('-')[0]; };
exports.getLanguage = getLanguage;
